import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs, { generateBreadcrumbsFromPath } from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import UserProductMembershipForm from '../UserProductMembershipForm';
import { Section } from 'components/ui/table/elements';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createUserProductMembership } from 'store/actions/users/product-memberships/createUserProductMembership';
import { fetchUser } from 'store/actions/users/fetchUsers';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

class UserProductMembershipCreateContainer extends Component {
    handleSubmit = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        const paymentMethod = values.payment_method ? 'deferred' : 'invoice';

        return new Promise((resolve, reject) => {
            return dispatchForm({
                onError: reject,
                onSuccess: () => {
                    resolve(history.push(`/users/${ id }/show`));
                },
                values: utils.filterEmptyValues({
                    ...values,
                    payment_method: paymentMethod,
                    user_id: id,
                }),
            });
        });
    }

    render() {
        const {
            data,
            id,
            resourceFetchLoading,
            resourceFetchFailed,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = generateBreadcrumbsFromPath({
            users: translate('resources.users.title'),
            [id]: {
                ...data,
                name: utils.fullName(data.first_name, data.last_name),
            },
            'product-memberships': translate('resources.product_memberships.title'),
        }, this.props);

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.users.product_memberships.actions.create') } />
                </Header>

                <Section>
                    <Column>
                        <InnerColumn>
                            <UserProductMembershipForm
                                initialValues={ {
                                    country_iso2: 'NL',
                                    currency: null,
                                    ends_at: null,
                                    group_identifier: null,
                                    is_scheduled: null,
                                    price: null,
                                    product_id: null,
                                    product_membership_id: null,
                                    starts_at: null,
                                    user_id: id,
                                    user_product_membership_pool_id: null,
                                    user_vehicle_id: null,
                                    vat_percentage: '',
                                    payment_method: false,
                                } }
                                form='user-product-membership-create'
                                onSubmit={ this.handleSubmit }
                                userId={ id }
                            />
                        </InnerColumn>
                    </Column>
                </Section>
            </div>
        );
    }
}

UserProductMembershipCreateContainer.propTypes = {
    data: PropTypes.object,
    history: PropTypes.object.isRequired,
    id: PropTypes.number.isRequired,
    dispatchForm: PropTypes.func.isRequired,
    resourceFetchFailed: PropTypes.bool,
    resourceFetchLoading: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (payload) => {
            return dispatch(createUserProductMembership(payload));
        },
    };
};

const enhance = compose(
    fetchResourceById({
        action: fetchUser,
        resource: 'users',
    }),
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(UserProductMembershipCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/users/product-memberships/create/UserProductMembershipCreateContainer.js